import React, { useEffect, useState } from "react";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { InputAdornment, TextField } from "@mui/material";
import Swal from "sweetalert2";

export const FiltroReporteRecuperacionCartera = ({
  onCargarReporteRecuperacion,
  onGeneraExcel,
}) => {
  const [openModal, setOpenModal] = useState(false);
  const [state, setState] = useState({
    fechainicio: "",
    fechafinal: "",
  });
  const onOpenModal = () => {
    var container = document.getElementById("FiltroRecuperacion-modal");
    if (container === undefined || container === null) return;
    if (openModal === true) {
      container.style.display = "flex";
      setOpenModal(false);
    } else {
      container.style.display = "none";
      setOpenModal(true);
    }
  };
  const onCargar = () => {
    if (
      state.fechainicio === undefined ||
      state.fechainicio === null ||
      state.fechainicio === ""
    ) {
      Swal.fire(
        "RECUPERACION DE CARTERA",
        "Favor de indicar la fecha de inicio",
        "warning"
      );
      return;
    }
    if (
      state.fechafinal === undefined ||
      state.fechafinal === null ||
      state.fechafinal === ""
    ) {
      Swal.fire(
        "RECUPERACION DE CARTERA",
        "Favor de indicar la fecha de final",
        "warning"
      );
      return;
    }
    onCargarReporteRecuperacion(state)
      .then(() => onOpenModal())
      .catch((error) => {
        Swal.fire("RECUPERACION DE CARTERA", JSON.stringify(error), "error");
      });

      // onGeneraExcel(state)
      //   .then(() => onOpenModal())
      //   .catch((error) => {
      //     Swal.fire("RECUPERACION DE CARTERA", JSON.stringify(error), "error");
      //   });
  };
  useEffect(() => {
    var container = document.getElementById("FiltroRecuperacion-modal");
    if (container === undefined || container === null) return;
    container.style.display = "none";
    setOpenModal(true);
  }, []);
  return (
    <div className="FiltroRecuperacion">
      <div
        className="recuperacion-cartera-header-filtrado"
        onClick={() => onOpenModal()}
      >
        <FilterAltIcon /> Filtrar
      </div>
      <div className="FiltroRecuperacion-modal" id="FiltroRecuperacion-modal">
        <div className="FiltroRecuperacion-modal-header">
          FILTRO DE REPORTE DE RECUPERACION DE CARTERA
        </div>
        <div className="FiltroRecuperacion-modal-fechas">
          <TextField
            size="small"
            type="date"
            label="Fecha de Inicio"
            format={"DD/MM/YYYY"}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start"></InputAdornment>
              ),
            }}
            value={state.fechainicio}
            onChange={({ target }) =>
              setState({ ...state, fechainicio: target.value })
            }
          />
          <TextField
            size="small"
            type="date"
            label="Fecha Final"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start"></InputAdornment>
              ),
            }}
            value={state.fechafinal}
            onChange={({ target }) =>
              setState({ ...state, fechafinal: target.value })
            }
          />
        </div>
        <div className="mdlFiltros-modal-acciones">
          <div
            className="mdlFiltros-modal-acciones-cancelar"
            onClick={() => onOpenModal()}
          >
            Cancelar
          </div>
          <div
            className="mdlFiltros-modal-acciones-guardar"
            onClick={() => onCargar()}
          >
            Cargar
          </div>
        </div>
      </div>
    </div>
  );
};
